var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehelixLogo01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1737 307",
    style: {
      enableBackground: "new 0 0 1737 307"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F66C57;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    transform: "translate(-192.516 -867.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    transform: "translate(254.405 868.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    className: "st0",
    d: "M661.1,39.7h56.1L640,257.3h-66.4L496.5,39.7h56.4l54,164.3L661.1,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    className: "st0",
    d: "M816.2,259.8c-50.8,0-87.4-34.1-87.4-89s36-89,87.4-89c50.5,0,86.2,33.5,86.2,86.2 c0,5.2-0.3,10.4-0.9,15.5h-120c1.9,22.6,15.8,33.2,32.9,33.2c11.8,0.8,22.8-5.9,27.6-16.8h56.5 C890,233.8,859.3,259.8,816.2,259.8z M781.7,154.1h66.4c0-16.5-13.4-29.9-29.9-29.9c-0.9,0-1.8,0-2.6,0.1 C798.2,123.7,783.3,136.8,781.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    className: "st0",
    d: "M930.3,27.9h53v79.7c12.6-16.6,32.5-25.9,53.3-25.1c39.4,0,65.7,27.3,65.7,73.8v101.1h-52.7 v-93.9c0-23.6-13-36.6-33.2-36.6s-33.2,13-33.2,36.6v94h-53L930.3,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    className: "st0",
    d: "M1216.2,259.8c-50.8,0-87.4-34.1-87.4-89s36-89,87.4-89c50.5,0,86.2,33.5,86.2,86.2 c0,5.2-0.3,10.4-0.9,15.5h-120c1.9,22.6,15.8,33.2,32.9,33.2c11.8,0.8,22.8-5.9,27.6-16.8h56.4 C1290,233.8,1259.3,259.8,1216.2,259.8z M1181.8,154.1h66.4c0-16.5-13.4-29.9-29.9-29.9c-0.9,0-1.8,0-2.6,0.1 C1198.2,123.7,1183.4,136.8,1181.8,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    className: "st0",
    d: "M1330.3,27.9h53v229.4h-53V27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    className: "st0",
    d: "M1416.8,37.8c-1.7-17.4,11-32.8,28.4-34.5c17.4-1.7,32.8,11,34.5,28.4s-11,32.8-28.4,34.5 c-1,0.1-1.9,0.1-2.9,0.2c-16.2,1.2-30.3-10.8-31.5-27C1416.9,38.8,1416.8,38.3,1416.8,37.8z M1421.8,84.3h53v173h-53L1421.8,84.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    className: "st0",
    d: "M1582.4,209.3l-27.9,48.1h-57.4l57.1-88.4l-58.7-84.7h59.6l33.2,47.8l27.9-47.8h57.4l-58,87.1 l59.6,85.9h-59.6L1582.4,209.3z"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    className: "st1",
    cx: 432,
    cy: 1016.7,
    r: 36.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    className: "st1",
    d: "M284.8,1115.5c-8.1-12.2-14.7-25.3-19.6-39.1c-16.4,25.8-42.7,43.6-72.7,49.2 c5.6,12.4,12.2,24.3,19.7,35.7C240.3,1153.5,265.6,1137.5,284.8,1115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    className: "st1",
    d: "M581.5,1017.3c-0.1-82.5-67-149.5-149.5-149.5l0,0c-43.2,0-84.3,18.7-112.6,51.3 c8.1,12.2,14.7,25.3,19.6,39c32.6-51.4,100.8-66.6,152.1-34c31.9,20.2,51.2,55.4,51.1,93.1c0.1,66.8,44.5,125.5,108.7,143.8 c7.5-11.3,14-23.3,19.6-35.6C618.9,1115.3,581.6,1070,581.5,1017.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    className: "st1",
    d: "M579.2,919.1c8.1,12.2,14.7,25.3,19.6,39c16.2-25.5,42.2-43.2,71.8-49.1 c-5.6-12.4-12.2-24.3-19.6-35.6C623.2,881.4,598.2,897.2,579.2,919.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    className: "st1",
    d: "M525,1076.4c-20.2,31.8-55.3,51.1-93,51.1l0,0c-60.9-0.1-110.2-49.4-110.3-110.3 c-0.1-67.2-44.9-126-109.6-144c-7.5,11.4-14.1,23.3-19.7,35.7c52.1,9.8,89.9,55.3,90,108.4c0.1,82.5,67,149.5,149.6,149.5l0,0 c43.2,0,84.3-18.7,112.6-51.3C536.5,1103.3,529.9,1090.2,525,1076.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehelixLogo01);
export default __webpack_public_path__ + "static/media/vehelix_logo-01.0f28fc0d.svg";
export { ForwardRef as ReactComponent };